export default __webpack_public_path__ + "static/media/care-1.c61f7c77.jpg";